
















































































import { InitModule } from '@/store/modules/init'
import { Component, Vue } from 'vue-property-decorator'
import { list, isEnable, isDisable, authorityDelete, groupDelete } from '@/api/authority'
import GroupOperationModal from './components/groupOperationModal.vue'
import AuthorityOperationModal from './components/authorityOperationModal.vue'
import AuthModal from './components/authModal.vue'
import { ListResponse } from './index.d'

@Component({
  name: 'Authority',
  components: {
    GroupOperationModal,
    AuthorityOperationModal,
    AuthModal
  }
})
export default class extends Vue {
  private appId = 0
  private activeName = '0'
  private authorityList: ListResponse[] = []
  private loading = false

  private groupId: number | null = null
  private groupName = ''
  private groupOperationDialogFlag = false

  private id: number | null = null
  private authorityOperationDialogFlag = false

  private authDialogFlag = false

  get appList() {
    return InitModule.appList
  }

  private async created() {
    await InitModule.GetAppList()
    if (this.appList.length > 0) this.appId = this.appList[0].id
    this.onLoad()
  }

  // 数据加载
  private async onLoad() {
    this.loading = true
    const { content } = await list<ListResponse[]>({ appId: this.appId })
    this.loading = false
    this.authorityList = content
  }

  // 平台切换
  private change() {
    this.onLoad()
  }

  // 组删除
  private async removeTab(index: string) {
    await groupDelete({ id: this.authorityList[parseInt(index)].id, appId: this.appId })
    this.$message.success('删除成功')
    this.onLoad()
  }

  // 打开操作弹窗（新增组/修改组）
  private openGroupOperationDialog(id: number | null, name: string) {
    this.groupId = id
    this.groupName = name
    this.groupOperationDialogFlag = true
  }

  // 打开操作弹窗（新增权限/修改权限）
  private openRoleOperationDialog(id: number | null) {
    this.id = id
    this.authorityOperationDialogFlag = true
  }

  // 弹窗回调
  private onDialogSubmit() {
    this.onLoad()
  }

  // 禁用or启用
  private handleDisableorEnable(id: number, status: number) {
    const tips = status === 1 ? '禁用' : '启用'
    this.$confirm(`是否${tips}该权限？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      status === 1 ? await isDisable({ id, appId: this.appId }) : await isEnable({ id, appId: this.appId })
      this.$message.success(`${tips}成功`)
      this.onLoad()
    })
  }

  // 授权
  private handleAuth(id: number) {
    this.id = id
    this.authDialogFlag = true
  }

  // 权限删除
  private async authorityDelete(id: number) {
    this.$confirm('是否删除该权限？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      await authorityDelete({ id, appId: this.appId })
      this.$message.success('删除成功')
      this.onLoad()
    })
  }
}

